// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1665":"7023fe1e","3111":"7023fe1e","3453":"7023fe1e","3475":"7023fe1e","3571":"d3b74a02","3998":"ad1b97f1","7465":"45d3f15d","8855":"7023fe1e"}[chunkId] + ".chunk.css";
};